import { Link } from "react-router-dom";

import styles from "./NotFoundPage.module.css";

export function NotFoundPage() {
  return (
    <div className={styles.root}>
      <div className={styles.code}>404</div>
      <h1 className={styles.title}>This page hasn&rsquo;t been written yet.</h1>
      <p className={styles.body}>
        The link you followed may be stale, or the feature isn&rsquo;t part of Phase 1.
      </p>
      <Link to="/" className={styles.link}>
        Return to dashboard
      </Link>
    </div>
  );
}
